import React from 'react';

import { Flex } from '@reckon-web/flex';

import {
  AppleIcon,
  GoogleIcon,
  MicrosoftIcon,
} from './singleSignOnButton/Icons';
import { SingleSignOnButton } from './singleSignOnButton/index';

export type SingleSignOnButtonsProps = {
  microsoft?: { onClick: () => void };
  google?: { onClick: () => void };
  apple?: { onClick: () => void };
};

export const SingleSignOnButtons = ({
  microsoft,
  google,
  apple,
}: SingleSignOnButtonsProps) => (
  <Flex direction="column" gap="small">
    {microsoft && (
      <SingleSignOnButton
        label="Continue with Microsoft"
        icon={<MicrosoftIcon />}
        onClick={microsoft.onClick}
      />
    )}

    {google && (
      <SingleSignOnButton
        label="Continue with Google"
        icon={<GoogleIcon />}
        onClick={google.onClick}
      />
    )}

    {apple && (
      <SingleSignOnButton
        label="Continue with Apple"
        icon={<AppleIcon />}
        onClick={apple.onClick}
      />
    )}
  </Flex>
);
